<template>
  <v-row class="section" :class="{'my-5': subsection, 'ma-5': !subsection}">
    <v-col>
      <v-row>
        <v-expansion-panels flat
          v-model="panel">
          <v-expansion-panel class="px-2 pb-3 pt-3" :class="{[color]: color, 'secondary': !color}"
            @click="open = !open">
            <v-expansion-panel-header>
              <v-row class="mr-3" align="center">
                <v-col cols="12" sm="6" md="8" justify="center">
                  <h2 v-if="title" class="primary--text d-inline">{{ title }}</h2>
                  <h4 v-if="subtitle" class="primary--text d-inline font-weight-light">{{ ' ' + subtitle }} </h4>
                </v-col>
                <v-col cols="6" sm="6" md="4" :align="$vuetify.breakpoint.smAndUp ? 'right' : 'left'">
                  <slot name="aside"></slot>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <slot name="body"></slot>
              <v-row class="my-5">
                <v-expansion-panels flat v-if="otherOptions">
                  <v-expansion-panel :class="{[otherOptionsColor]: otherOptionsColor, 'tertiary': !otherOptionsColor}">
                    <v-expansion-panel-header>
                      {{ $t('sections.other_options') }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <slot name="otherOptions"></slot>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
              <slot name="extra"></slot>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-row v-if="footerAddon" v-show="open" class="primary footer-addon pointer"
        @click="$emit('footerAddonClick')">
        <slot name="footerAddon"></slot>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      open: true,
      panel: 0
    }
  },
  props: {
    title: String,
    subtitle: String,
    otherOptions: Boolean,
    otherOptionsColor: String,
    footerAddon: Boolean,
    color: String,
    subsection: Boolean
  }
}
</script>

<style lang="scss" scoped>
.section {
  border-radius: 5px;
}
.footer-addon {
  border-radius: 0px 0px 5px 5px;
}
</style>
